import React, { JSXElementConstructor, ReactElement } from 'react';
import styled from 'styled-components';
import { useHover } from '@uidotdev/usehooks';

interface IProps {
  children: any;
  color: string;
  hoverColor: string;
}

const ButtonWrapper: React.FC<IProps> = ({ children, hoverColor, color }) => {
  const [ref, hovering] = useHover();
  const colorIcon = hovering ? hoverColor : color;
  const variant = hovering ? 'Bold' : 'Linear';
  // const clonedElement = React.cloneElement(children) as ReactElement<any, string | JSXElementConstructor<any>>;
  // const childProps = clonedElement.props.children?.props;
  // if (childProps) {
  //   childProps.variant = 'Bold';
  // }
  return (
    <ItemWrapper ref={ref} style={{ color: colorIcon }}>
      {React.cloneElement(children, { variant })}
    </ItemWrapper>
  );
};

export default ButtonWrapper;

const ItemWrapper = styled.div`
  cursor: pointer;
`;
